/* eslint-disable no-loop-func */
/* eslint-disable guard-for-in */
import angular from 'angular';
/**
 * Components
 */
import '../../../../../components/recruiter_folder_select/recruiter_folder_select.component';
import '../discover_similar_profile/discover_similar_profile.module';
/**
 * Services
 */
import '../../../../../../../lib/assets/javascripts/devex/angular/services/routes.service';
import '../../../../../../../lib/assets/javascripts/devex/angular/models/alert_handling_service';
import { removeTaggings, queryTaggings } from '../../../../../utilities/angular/tags_helper';
/**
 * Component's template
 */
import template from './recruiter_tools.html?raw';

const dependencies = [
  'services.RoutesService',
  'models.alertHandlingService',
  'components.recruiterFolderSelect',
  'peopleSearch.components.discoverSimilarProfile'
];

const bindings = {
  selectedResults: '<',
  credits: '<',
  selectedFolders: '<',
  onPageChange: '<',
};

const options = {
  templateUrl: template,
  controller: [
    '$scope',
    'RoutesService',
    'alertHandlingService',
    function ($scope, Routes, AlertHandling) {
      var that = this;

      that.$scope = $scope;
      that.Routes = Routes;
      that.AlertHandling = AlertHandling;
      that.recruiterToolsOptions = {
        noteContentModel: '',
        isNoteFormOpen: false,
        isFolderFormOpen: false,
      };
      that.requestLoading = false;
      that.saveNotesLoading = false;
      that.flipper = devex.flipper;

      /**
       * Loops in the list of consultants selected, if the consultant
       * has a cv and was not previously requested request the CV.
       * Shows a success or error message depending on the result.
       *
       * @param {object} consultants - consultants selected
       *
       * @returns {undefined}
       */
      that.bulkRequestCV = (consultants) => {
        let successRequests = 0;
        that.requestLoading = true;
        let promises = [];
        for (const key in consultants) {
          if (!consultants[key].cvRequested) {
            let promise = new Promise((resolve, reject) => {
              fetch(`/api/public/consultants/${consultants[key].id}/request_cv`, { method: 'POST' })
                .then((res) => {
                  if (res.status === 201) {
                    successRequests += 1;
                    consultants[key].cvRequested = true;
                  }
                  resolve(res);
                })
                .catch((err) => reject(err));
            });
            promises.push(promise);
          }
        }
        if (promises.length) {
          Promise.all(promises)
            .then(() => {
              if (successRequests) {
                const message = `Success CVs requested ${successRequests} of ${promises.length}`;
                devex.alerts.showAlert(message, 'success');
              } else {
                devex.alerts.showAlert('An error has occurred requesting the CVs', 'error');
              }
              that.requestLoading = false;
              that.$scope.$apply();
            })
            .catch(() => {
              that.requestLoading = false;
              devex.alerts.showAlert('An error has occurred requesting the CVs', 'error');
              that.$scope.$apply();
            });
        } else {
          that.requestLoading = false;
          devex.alerts.showAlert('An error has occurred requesting the CVs', 'error');
        }
      };

      /**
       * If there are consultants selected returns true
       * otherwise returns false and close the recruiter tools fields.
       *
       * @returns {boolean} - if the user can access the bulk tools
       */
      that.canAccessBulkTools = () => {
        const consultantsSelected = Object.keys(that.selectedResults);
        if (consultantsSelected.length) return true;
        that.recruiterToolsOptions.isNoteFormOpen = false;
        that.recruiterToolsOptions.isFolderFormOpen = false;
        return false;
      };

      /**
       * Open the field selected, focus the input and close the other inputs in
       * case they are open.
       *
       * @param {string} toggleName - option selected
       * @param {string} unselect - option to close
       * @param {string} focusId - input to focus
       *
       * @returns {undefined}
       */
      that.toggleRecruiterTool = (toggleName, unselect, focusId) => {
        that.recruiterToolsOptions[toggleName] = !that.recruiterToolsOptions[toggleName];
        that.recruiterToolsOptions[unselect] = false;
        const element = document.getElementById(focusId);
        if (that.recruiterToolsOptions[toggleName] && element) {
          element.focus();
        }
      };

      /**
       * Remove candidates from folders selected.
       * First gets all the candidates taggings using the helper method
       * queryTaggings and the candidates id, then filters the taggings
       * to get only the ones that match the folders selected and finally,
       * remove the taggings using the helper method removeTaggings and the filtered taggings id.
       */
      that.removeCandidates = () => {
        const candidatesId = Object.keys(that.selectedResults);

        queryTaggings(candidatesId).then(({ data }) => {
          const filteredTaggings = data.filter((tagging) => {
            return that.selectedFolders.includes(tagging.tag.id);
          });

          const taggingsId = filteredTaggings.map((tagging) => tagging.id);
          removeTaggings(taggingsId).then(() => {
            that.onPageChange();
            that.AlertHandling.showSuccessMessage(
              `Candidate${candidatesId.length > 1 ? 's' : ''} removed`
            );
          });
        });
      };

      /**
       * Redirect the user to the contact candidates page with the selected candidates.
       *
       * @returns {undefined}
       */
      that.bulkMessage = () => {
        const candidateIDs = Object.keys(that.selectedResults);
        if (candidateIDs.length) {
          window.location = that.Routes.new_message_path({
            recipient_ids: candidateIDs,
            return_to: window.location.href,
          });
        }
      };

      /**
       * If the user has more credits than candidates selected
       * returns true else false.
       *
       * @returns {boolean} - if the user can send messages
       */
      that.sendButtonDisabled = () => {
        const candidateIDs = Object.keys(that.selectedResults);
        return that.canAccessBulkTools() && that.credits.available >= candidateIDs.length;
      };

      /**
       * Loops in the candidates selected and saves the note in each candidate
       * then shows a message with the amount of notes added successfully or
       * an error message.
       * Cleans the field and close the option.
       *
       * @param {object} consultants - consultants selected
       *
       * @returns {undefined}
       */
      that.saveBulkNote = (consultants) => {
        let notes = 0;
        that.saveNotesLoading = true;
        let promises = [];
        for (const key in consultants) {
          const data = {
            note: {
              notable_type: 'Consultant',
              notable_id: consultants[key].id,
              note: that.recruiterToolsOptions.noteContentModel,
            },
          };
          const postOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
          };
          let promise = new Promise((resolve, reject) => {
            fetch('/api/public/current_user/notes', postOptions)
              .then((response) => {
                if (response.status === 201) {
                  notes += 1;
                }
                resolve();
              })
              .catch(() => reject());
          });
          promises.push(promise);
        }
        Promise.all(promises)
          .then(() => {
            that.saveNotesLoading = false;
            if (notes) {
              that.recruiterToolsOptions.noteContentModel = '';
              that.recruiterToolsOptions.isNoteFormOpen = false;
              devex.alerts.showAlert(`Success notes added ${notes}`, 'success');
            } else {
              devex.alerts.showAlert('An error has occurred adding the notes', 'error');
            }
            that.$scope.$apply();
          })
          .catch(() => {
            devex.alerts.showAlert('An error has occurred adding the notes', 'error');
          });
      };

      /**
       * Returns the total amount of consultants selected.
       *
       * @returns {number} - amount of consultants selected
       */
      that.getSelectedConsultantsLength = () => {
        return Object.keys(that.selectedResults).length;
      };

      /**
       * Check if the amount of credits is bigger than the number
       * of consultants selected if it's returns true else false.
       *
       * @returns {boolean} - if the user can send messages
       */
      that.showCreditsMessage = () => {
        return Object.keys(that.selectedResults).length > that.credits.available;
      };
    },
  ],
  controllerAs: 'vm',
  bindings,
};

angular
  .module('components.recruiterToolsComponent', dependencies)
  .run(['$templateCache', function ($templateCache) {
    $templateCache.put(template, template);
  }])
  .component('recruiterToolsComponent', options);
